import { Expose, Type } from 'class-transformer';
import { Model } from './model';
import { EnthusiastsStatisticsStudentModel } from './enthusiasts-statistics-student-model';

export class EnthusiastsStatisticsModel extends Model {
  @Expose()
  @Type(() => EnthusiastsStatisticsStudentModel)
  mostReciters: EnthusiastsStatisticsStudentModel[];

  @Expose()
  @Type(() => EnthusiastsStatisticsStudentModel)
  studentsWithMostCalls: EnthusiastsStatisticsStudentModel[];
}
